import { z } from "zod";
import { tokenAliasOrValue } from "./base";

export const TextCase = z.enum(["Original", "Upper", "Lower", "Camel", "SmallCaps"]);
export const TextCaseValue = TextCase;
export const TextCaseTokenData = tokenAliasOrValue(TextCaseValue);

export type TextCase = z.infer<typeof TextCase>;
export type TextCaseValue = z.infer<typeof TextCaseValue>;
export type TextCaseTokenData = z.infer<typeof TextCaseTokenData>;
